import smileysAndPeopleEmmojis from '../smileysAndPeople';
import animalsAndNatureEmojis from '../animalsAndNature';
import foodAndDrinkEmojis from '../foodAndDrink';
import activityEmojis from '../activity';
import travelAndPlacesEmojis from '../travelAndPlaces';
import objectsEmojis from '../objects';
import symbolsEmojis from '../symbols';
import flagsEmojis from '../flags';

const allEmojis = [
  smileysAndPeopleEmmojis,
  animalsAndNatureEmojis,
  foodAndDrinkEmojis,
  activityEmojis,
  travelAndPlacesEmojis,
  objectsEmojis,
  symbolsEmojis,
  flagsEmojis,
];

export default allEmojis;
